const checkPhoneNumberTransformer = response => ({
  ...response,
  isAllocationPossible: response?.clientReallocationStatus?.isClientReAllocationPossible ?? false,
  userId: response?.data?.Client?.User?.id,
  source:response?.clientReallocationStatus?.data?.clientSource,
})

export default checkPhoneNumberTransformer
